import React from "react";
import TextField from "../../../components/forms/TextField/TextField";

const AccountInfo = ({ register, errors, user }) => {
  return (
    <div className="space-y-4">
      <div className="flex flex-col md:flex-row gap-4">
        {/* First Name */}
        <TextField
          label="First Name"
          required
          {...register("first_name", {
            required: "First name is required",
            value: user.first_name,
          })}
          error={errors.first_name}
          placeholder="First Name"
        />

        {/* Middle Name */}
        <TextField
          label="Middle Name"
          {...register("middle_name", {
            value: user.middle_name,
          })}
          placeholder="Middle Name (Optional)"
        />
      </div>

      {/* Last Name */}
      <TextField
        label="Last Name"
        required
        {...register("last_name", {
          required: "Last name is required",
          value: user.last_name,
        })}
        error={errors.last_name}
        placeholder="Last Name"
      />

      {/* Email */}
      <TextField
        label="Email"
        type="email"
        disabled
        // className="disabled:bg-gray-200 dark:bg-gray-800 dark:text-whit"
        required
        {...register("email", {
          required: "Email is required",
          value: user.email,
          pattern: {
            value: /\S+@\S+\.\S+/,
            message: "Invalid email address",
          },
        })}
        error={errors.email}
        placeholder="Email Address"
      />
    </div>
  );
};

export default AccountInfo;
